import { ChangeEvent, useCallback, useState } from "react";
import { getCustomerList, searchCustomer } from "src/apis/customerApi";


import useUiuxStore from "src/store/useUiuxStore";
import { defaultSAL2070_R01Filter, useSAL2070_R01Store } from "src/containers/mes/SAL/SAL2070_R01/Store_SAL2070_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

interface Props {
  onEnterKeyDown: () => void;
}

export const SearchSection_SAL2070_R01 = (props: Props) => {

	const { onEnterKeyDown } = props;
	const { SAL2070_R01Filter, setSAL2070_R01Filter } = useSAL2070_R01Store();

    const { codeSearchModalVisible, setCodeSearchModalProps } = useUiuxStore();
	const { vatIoFlagList, yesNoList, customCdList, compCdList } = useCommonCodeStore();

    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const custInfoHandleFoucsId = 'infoCustInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				compCd: SAL2070_R01Filter.compCd || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: SAL2070_R01Filter,
		setEditData: setSAL2070_R01Filter,
		defaultData: defaultSAL2070_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL2070_R01_search'
	});

	const expandSearch = () => {
		return (
			<>

				{/* 거래처 입력 및 검색 영역 */}
				<SearchCodeModalForm
					label="거래처"
					value={SAL2070_R01Filter.customCd}
					valueLabel={customCdList.find(value => value.customCd === SAL2070_R01Filter.customCd)?.customNm || ''}
					onChange={getFieldHandlers('customCd').onChange}
					onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
				/>
			</>	
		)
	}

    // UI 렌더링
    return (
		<>
		<SearchSectionForm expandSearch={expandSearch}>
			<SearchDateRangeForm
				label="정보 조회 기간"
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]',
				}}
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={SAL2070_R01Filter.dateRange}		setDateRange={(dateRange) => setSAL2070_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm
				label="계산서구분"
				value={SAL2070_R01Filter.tradeType}
				onChangeItem={(item) => setSAL2070_R01Filter({ tradeType: item?.minorCd || ''})}
				optionList={vatIoFlagList}
				wrapperOption={{
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[60px] min	-w-[60px]",
					selectStyle: "w-[120px] min-w-[90px] border border-gray-300 px-[6px] h-[24px] rounded-[6px]",
				}}
			/>
			<SearchDropDownForm
					label="발행여부"
					value={SAL2070_R01Filter.taxBilling}
					onChangeItem={(item) => setSAL2070_R01Filter({ taxBilling: item?.minorCd || ''})}
					optionList={yesNoList.map(item => ({ ...item, codeNm: item.minorCd === 'Y' ? '발행' : '미발행' }))}
				/>
		</SearchSectionForm>
		{/* searchedCustomer : {JSON.stringify(searchedCustomer)} */}
		</>
	)
}

export default SearchSection_SAL2070_R01;